import React, { FC, forwardRef } from 'react';
import { Button, ButtonProps } from '@beeline.com/bp-design-system';
import { AppLinkWithWrapper, AppLinkWithWrapperBaseProps } from './AppLinkWithWrapper';

export interface AppLinkProps extends AppLinkWithWrapperBaseProps {
  button?: boolean;
  buttonProps?: ButtonProps;
}

export const AppLink: FC<React.PropsWithChildren<AppLinkProps>> = forwardRef<HTMLAnchorElement, AppLinkProps>(
  ({ button, buttonProps, ...rest }, ref) => (
    <AppLinkWithWrapper {...rest} Component={button ? Button : undefined} componentProps={buttonProps} ref={ref} />
  )
);

export default AppLink;
